import { createAxiosInstance } from "./axiosInstance";

//Login With Wallet
export const loginWithWallet = async (token, wallet) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = { 
    Emailid: "", 
    Password: "", 
    WalletAddress: wallet 
  };
  const response = await axiosInstance.post("/api/v1/login", payload);
  return response.data;
};




//Direct Login From Admin
export const directLogin = async (token, LoginToken) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = { 
    LoginToken: LoginToken
  };
  const response = await axiosInstance.post("/api/v1/direct-login", payload);
  return response.data;
};

// Get Sponsor Incase User Does Not Have
export const getSponsor = async (token) => {
  const axiosInstance = createAxiosInstance(token);
  const response = await axiosInstance.get("/api/v1/getsponsor");
  return response.data;
};




//Register With Wallet
export const registerWithWallet = async (token, sponsorId, wallet) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        Sponsor: sponsorId,
        Username: "",
        Name: "",
        Emailid: "",
        MobileNo: "",
        WalletAddress: wallet,
        Country: "0",
        Password: "",
        Mode: "1",
  };
  const response = await axiosInstance.post("/api/v1/registration", payload);
  return response.data;
};



//Load Token Wallet Statement
export const tokenWalletStatement = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE,
  };
  const response = await axiosInstance.post("/api/v1/tokenwalletstatement", payload);
  return response.data;
};

//Load Earning Statement
export const earningWalletStatement = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE,
  };
  const response = await axiosInstance.post("/api/v1/tokenwalletstatement", payload);
  return response.data;
};



//Load USDT Withdrawal History
export const USDTWithdrawalHistory = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE,STATUS) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE,
        STATUS:STATUS
  };
  const response = await axiosInstance.post("/api/v1/withdrawalhistory", payload);
  return response.data;
};




//Load Direct Bonus History
export const directBonusHistory = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE
  };
  const response = await axiosInstance.post("/api/v1/DirectIncome", payload);
  return response.data;
};


//Load Level Bonus History
export const levelBonusHistory = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE
  };
  const response = await axiosInstance.post("/api/v1/levelincome", payload);
  return response.data;
};


//Load ROI Bonus History
export const roiBonusHistory = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE
  };
  const response = await axiosInstance.post("/api/v1/stakingincome", payload);
  return response.data;
};

//Load Weekly Bonus History
export const WeeklyBonusHistory = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE
  };
  const response = await axiosInstance.post("/api/v1/weeklyincome", payload);
  return response.data;
};

//Load Level Income Eligible
export const LevelIncomeElegible = async (token, LoginToken) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
       
  };
  const response = await axiosInstance.post("/api/v1/incomeligible", payload);
  return response.data;
};

//Load ROI Bonus History
export const TotalroiBonusHistory = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE
  };
  const response = await axiosInstance.post("/api/v1/totalroiincome", payload);
  return response.data;
};


//Load USDT Wallet Statement
export const USDTWalletStatement = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE,
  };
  const response = await axiosInstance.post("/api/v1/usdtwalletstatement", payload);
  return response.data;
};

//Request USDT Withdrawal
export const requestUSDTWithdrawal = async (token, LoginToken, TYPE, WALLETADDRESS, AMOUNT) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,     
        WALLETADDRESS: WALLETADDRESS,
        AMOUNT: AMOUNT,
        TYPE: TYPE
  };
  const response = await axiosInstance.post("/api/v1/withdrawal-request", payload);
  return response.data;
};

//Load USDT Wallet Balance
export const loadUSDTWalletBalance = async (token, LoginToken, TYPE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        TYPE: TYPE
  };
  const response = await axiosInstance.post("/api/v1/GetAvaliableBalance", payload);
  return response.data;
};

//Withdrawal OTP
export const sendOtpWithdrawal = async (token,LoginToken, WalletAddress,Mode,Amount,Type) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = { 
    LoginToken: LoginToken,
    Mode:Mode,
    WalletAddress: WalletAddress,
    Amount: Amount,
    Type:Type
  };
  const response = await axiosInstance.post("/api/v1/withdrawalotp", payload);
  return response.data;
};


//Load All Affiliate List
export const allAffiliateList = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE,
        LEVEL:"",
        SEARCHTEAM:""
  };
  const response = await axiosInstance.post("/api/v1/myteam", payload);
  return response.data;
};

//Load Direct Affiliate List
export const directAffiliateList = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE
  };
  const response = await axiosInstance.post("/api/v1/directreferral", payload);
  return response.data;
};


//Load Purchase History
export const purchaseHistoryList = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE
  };
  const response = await axiosInstance.post("/api/v1/allPackagehistory", payload);
  return response.data;
};

//Load Package Details
export const PackageDetails = async (token, LoginToken) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken
        
  };
  const response = await axiosInstance.post("/api/v1/packagesdetails", payload);
  return response.data;
};

//Load Ticket History
export const loadTicketHistory = async (token, LoginToken, PAGE,MAXROWS,SEARCHFIELD,SEARCHVALUE,FROMDATE,TODATE,STATUS) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        PAGE: PAGE,
        MAXROWS: MAXROWS,
        SEARCHFIELD: SEARCHFIELD,
        SEARCHVALUE: SEARCHVALUE,
        FROMDATE: FROMDATE,
        TODATE: TODATE,
        STATUS:STATUS
  };
  const response = await axiosInstance.post("/api/v1/ticketlist", payload);
  return response.data;
};


//Load Ticket History
export const TicketDetails = async (token, LoginToken,tid) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
       TMID:tid
  };
  const response = await axiosInstance.post("/api/v1/ticketdetails", payload);
  return response.data;
};

//Create Ticket
export const generateTicket = async (token,LoginToken,CategoryId,Category,Subject,Message,Image) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken,
        CategoryId: CategoryId,
        Category: Category,
        Subject: Subject,
        Message: Message,
        Image: Image
  };
  const response = await axiosInstance.post("/api/v1/createticket", payload);
  return response.data;
};

//Ticket Reply
export const TicketReply = async (token,Message,Image,tid) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        TMID:tid,
        Message: Message,
        Image: Image
  };
  const response = await axiosInstance.post("/api/v1/ticketreply", payload);
  return response.data;
};




// Upload Image API
export const uploadImage = async (token, file) => {
  try {
    const axiosInstance = createAxiosInstance(token);
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post(
      "/api/v1/imageuploader",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data", },
      }
    );
    return response.data; // you can destructure status/data in calling function
  } 
  catch (error) {
    console.error("Image Upload Error:", error);
    return { status: false, error: error.message };
  }
};



//Load Dashboard Data
export const loadDashboardData = async (token,LoginToken) => {
  const axiosInstance = createAxiosInstance(token);
  const payload = {
        LoginToken: LoginToken
  };
  const response = await axiosInstance.post("/api/v1/dashboard", payload);
  return response.data;
};

//Approved Desposit
export const ApprovedDeposit = async (token,LoginToken, Wallet, Amount,TokenAmount) => {

  const axiosInstance = createAxiosInstance(token);
  const payload = {
    LoginToken:LoginToken, 
    Wallet: Wallet,
    Amount:Amount,
    TokenAmount:TokenAmount
  };
  const response = await axiosInstance.post("/api/v1/approveddeposit", payload);
  return response.data;
};

//Register API
export const registerWithAPIWallet = async (token, WalletAddress) => {

  const axiosInstance = createAxiosInstance(token);
  const payload = {
    WalletAddress: WalletAddress   
  };
  const response = await axiosInstance.post("/api/v1/RegistrationApi", payload);
  return response.data;
};
